import React, {useEffect} from "react"
import {BrowserRouter as Router, Route, Routes} from "react-router-dom"
import Layout from "./layouts/Layout"
import LoadingBlock from "./components/LoadingBlock"
import {withAuthenticationRequired} from "@auth0/auth0-react"
import Loader from "./components/Loader"
import {useWebsocket} from "./hooks/useWebsocket"
import ErrorPage from "./layouts/error-pages/ErrorPage"
import {setCookie} from "./utils/cookies"

const MainPage = React.lazy(() => import("features/main/Main"))
const BranchPage = React.lazy(() => import("features/branches/BranchPage"))

const App = () => {
  const {loading} = useWebsocket()

  useEffect(() => {
    Notification.requestPermission().then((result) => {
      if (result === "granted") {
        setCookie("notification_access", "granted")
        console.log("Permission granted")
      } else if (result === "denied") {
        setCookie("notification_access", "denied")
        console.log("Permission denied")
      } else {
        setCookie("notification_access", "dismissed")
        console.log("Permission dismissed")
      }
    })
  }, [])

  if (loading) return <LoadingBlock />
  return (
    <Router>
      <Layout>
        <React.Suspense fallback={<LoadingBlock />}>
          <Routes>
            <Route path={"/"} element={<MainPage />} />
            <Route path={"/branch/:id"} element={<BranchPage />} />
            <Route
              path={"*"}
              element={
                <ErrorPage
                  status={"404"}
                  title={"404"}
                  subTitle={"Вы вошли на несуществующую страницу!"}
                />
              }
            />
          </Routes>
        </React.Suspense>
      </Layout>
    </Router>
  )
}

export default withAuthenticationRequired(App, {
  onRedirecting: () => <Loader />
})
